import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";
import PageContainer from "../components/PageContainer";
import Footer from "../components/Footer/Footer";
import HelpPopup from "../components/HelpPopUp";
import { ChatWidgetProvider } from "../context/ChatWidgetProvider";
import EssentialStorageAlert from "../components/EssentialStorageAlert";
import { useBranding } from "../context/BrandingContext";
import LeftSidebarLayout from "./LeftSidebarLayout";
import PromotionExpiryNotice from "../components/PromotionExpiryNotice";

const MainLayout = () => {
  const { branding } = useBranding();

  if (branding?.layout === 4) {
    return <LeftSidebarLayout />;
  }

  return (
    <ChatWidgetProvider>
      <div style={{
        minHeight: '100dvh',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Navbar />
        <div style={{
          flex: '1 0 auto',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: 'var(--app-navbar-height)',
        }}>
          <div style={{ paddingTop: "16px" }}>
            <EssentialStorageAlert />
          </div>
          <PageContainer style={{ flex: '1 0 auto', width: '100%' }}>
            <PromotionExpiryNotice />
            <Outlet />
          </PageContainer>
        </div>
        <Footer />
        <HelpPopup />
      </div>
    </ChatWidgetProvider>
  );
};

export default MainLayout;
